<div class="col-12 col-sm-auto" *ngIf="isModalOpen">
  <div *ngIf="showTransferModal">
    <app-transfer-sub-assets-modal
      [openModal]="showTransferModal"
      [asset]="asset"
      [type]="type"
      [pinOrKeyringPassword]="pinOrKeyringPassword"
      (modalClose)="showTransferModal = false"
      (transfer)="triggerTransferAction($event)"
    ></app-transfer-sub-assets-modal>
  </div>

  <ng-container [ngSwitch]="type">
    <app-reserve-modal
      *ngSwitchCase="AssetActionModalType.RESERVE"
      [openReserveModal]="true"
      [asset]="asset"
      [assets]="selectedIds"
      [showMessage]="showMessage"
      (modalClose)="closeModal($event)"
    ></app-reserve-modal>
    <app-move-modal
      *ngSwitchCase="AssetActionModalType.MOVE"
      [openMoveModal]="true"
      [asset]="asset"
      [transferData]="transferData"
      [twoStepEnabled]="twoStepEnabled"
      [showMessage]="showMessage"
      [assetIds]="selectedIds"
      [selectedAssets]="selectedAssets"
      (openTransferModal)="showTransferModal = true"
      (modalClose)="closeModal($event)"
    ></app-move-modal>
    <app-checkout-modal
      *ngSwitchCase="AssetActionModalType.CHECKOUT"
      [openCheckoutModal]="true"
      [transferData]="transferData"
      [twoStepEnabled]="twoStepEnabled"
      (openTransferModal)="showTransferModal = true"
      [pinOrKeyringPassword]="pinOrKeyringPassword"
      [selectedAssets]="selectedAssets"
      [asset]="asset"
      [showMessage]="showMessage"
      [selectedIds]="selectedIds"
      (modalClose)="closeModal($event)"
      [isGuest]="isGuest"
    ></app-checkout-modal>
    <app-allocate-modal
      *ngSwitchCase="AssetActionModalType.ALLOCATE"
      [openAllocateModal]="true"
      [transferData]="transferData"
      [twoStepEnabled]="twoStepEnabled"
      (openTransferModal)="showTransferModal = true"
      [pinOrKeyringPassword]="pinOrKeyringPassword"
      [asset]="asset"
      [showMessage]="showMessage"
      [assets]="selectedIds"
      [isGuest]="isGuest"
      (modalClose)="closeModal($event)"
    ></app-allocate-modal>
    <app-deallocate-modal
      *ngSwitchCase="AssetActionModalType.DEALLOCATE"
      [openDeallocateModal]="true"
      [asset]="asset"
      [showMessage]="showMessage"
      [assets]="selectedIds"
      (modalClose)="closeModal($event)"
    ></app-deallocate-modal>

    <app-is-active-modal
      *ngSwitchCase="AssetActionModalType.Status"
      [openIsActiveModal]="true"
      [asset]="asset"
      [assets]="selectedIds"
      [showMessage]="showMessage"
      (modalClose)="closeModal($event)"
    ></app-is-active-modal>
  </ng-container>
</div>
